<template>
  <div id="error-alert">
    <div class="pap-form__error-alert" v-if="showAlert">{{msg}}</div>
  </div>
</template>

<script>
export default {
  name: "FormErrorAlert",
  props: ["showAlert", "msg"],
};
</script>

<style>
</style>